import { RideAddPassengerViewStationsEnum } from "@ryde/shared";

export interface IAddPassengerFormModel {
  passengerAddId?: number;
  stationFromId?: number;
  stationToId?: number;
  seats: number;
  viewStationsOption: RideAddPassengerViewStationsEnum;
}

export enum AddPassengerFormNames {
  passengerAddId = "passengerAddId",
  seats = "seats",
  stationFromId = "stationFromId",
  stationToId = "stationToId",
}
